/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CallerRef,
  CreateReportRequest,
  CreateReportResponse,
  DescribeReportResponse,
  MapString,
  PaginatedResultReportItem,
  PaginatedResultSharedReportItem,
  RunReportRequest,
  ShareReportRequest,
  StartReportRequest,
  UnshareReportRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "reporting-agent";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description List user's own reports with pagination
   *
   * @name ListReports
   * @request GET:/v1/tenants/{tenantId}/reports
   * @secure
   */
  listReports = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultReportItem,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listReports */
  listReportsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenants/${tenantId}/reports`, query);

  /**
   * @description Create a new report
   *
   * @name CreateReport
   * @request POST:/v1/tenants/{tenantId}/reports
   * @secure
   */
  createReport = (tenantId: string, data: CreateReportRequest, params: RequestParams = {}) =>
    this.request<
      CreateReportResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createReport */
  createReportPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenants/${tenantId}/reports`);

  /**
   * @description Create a new report and start streaming SSE events from Cortex Agent
   *
   * @name StartReport
   * @request POST:/v1/tenants/{tenantId}/reports/start
   * @secure
   */
  startReport = (tenantId: string, data: StartReportRequest, params: RequestParams = {}) =>
    this.request<
      Record<string, any>,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/start`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for startReport */
  startReportPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenants/${tenantId}/reports/start`);

  /**
   * @description Continue an existing report and stream SSE events from Cortex Agent
   *
   * @name RunReport
   * @request POST:/v1/tenants/{tenantId}/reports/run
   * @secure
   */
  runReport = (tenantId: string, data: RunReportRequest, params: RequestParams = {}) =>
    this.request<
      Record<string, any>,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/run`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for runReport */
  runReportPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenants/${tenantId}/reports/run`);

  /**
   * @description List reports shared with the user
   *
   * @name ListSharedReports
   * @request GET:/v1/tenants/{tenantId}/reports/shared
   * @secure
   */
  listSharedReports = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSharedReportItem,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/shared`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSharedReports */
  listSharedReportsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenants/${tenantId}/reports/shared`, query);

  /**
   * @description Describe a report with its associated thread content
   *
   * @name DescribeReport
   * @request GET:/v1/tenants/{tenantId}/reports/{reportId}
   * @secure
   */
  describeReport = (tenantId: string, reportId: string, params: RequestParams = {}) =>
    this.request<
      DescribeReportResponse,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/${reportId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for describeReport */
  describeReportPathGetter = (tenantId: string, reportId: string) =>
    this.getServicePath(`/v1/tenants/${tenantId}/reports/${reportId}`);

  /**
   * @description Submit positive feedback (value 8) for a report
   *
   * @name ThumbsUp
   * @request POST:/v1/tenants/{tenantId}/reports/{reportId}/thumbs-up
   * @secure
   */
  thumbsUp = (tenantId: string, reportId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/${reportId}/thumbs-up`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for thumbsUp */
  thumbsUpPathGetter = (tenantId: string, reportId: string) =>
    this.getServicePath(`/v1/tenants/${tenantId}/reports/${reportId}/thumbs-up`);

  /**
   * @description Submit negative feedback (value 2) for a report
   *
   * @name ThumbsDown
   * @request POST:/v1/tenants/{tenantId}/reports/{reportId}/thumbs-down
   * @secure
   */
  thumbsDown = (tenantId: string, reportId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/${reportId}/thumbs-down`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for thumbsDown */
  thumbsDownPathGetter = (tenantId: string, reportId: string) =>
    this.getServicePath(`/v1/tenants/${tenantId}/reports/${reportId}/thumbs-down`);

  /**
   * @description Share a report with another user
   *
   * @name ShareReport
   * @request POST:/v1/tenants/{tenantId}/reports/{reportId}/share
   * @secure
   */
  shareReport = (tenantId: string, reportId: string, data: ShareReportRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/${reportId}/share`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for shareReport */
  shareReportPathGetter = (tenantId: string, reportId: string) =>
    this.getServicePath(`/v1/tenants/${tenantId}/reports/${reportId}/share`);

  /**
   * @description Unshare a report with another user
   *
   * @name UnshareReport
   * @request POST:/v1/tenants/{tenantId}/reports/{reportId}/unshare
   * @secure
   */
  unshareReport = (tenantId: string, reportId: string, data: UnshareReportRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenants/${tenantId}/reports/${reportId}/unshare`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for unshareReport */
  unshareReportPathGetter = (tenantId: string, reportId: string) =>
    this.getServicePath(`/v1/tenants/${tenantId}/reports/${reportId}/unshare`);
}
